import React from "react";
import { Link } from "react-scroll";
import { BiHomeAlt, BiUser, BiCodeAlt } from "react-icons/bi";

export default function Navigation() {
    return (
        <div className="fixed bottom-8 left-0 right-0 text-center z-10 lg:translate-y-[40%] lg:top-auto lg:left-auto lg:right-5">
            <div className="flex justify-between mx-auto bg-white text-secondary p-2 rounded-full border-secondary border-solid border-[1px] max-w-[100%] md:max-w-[300px] lg:max-w-[60px] lg:flex-col">
                
                <Link 
                    className="flex w-[50px] h-[50px] md:w-[60px] md:h-[60px] justify-center items-center cursor-pointer rounded-full" 
                    to="home" 
                    activeClass="active" 
                    offset={-100} 
                    smooth={true} 
                    spy={true} 
                    duration={500}>
                    <BiHomeAlt className="text-xl md:text-2xl cursor-pointer hover:text-primary transition" />
                </Link>
                
                <Link 
                    className="flex w-[50px] h-[50px] md:w-[60px] md:h-[60px] justify-center items-center cursor-pointer rounded-full" 
                    to="profil" 
                    activeClass="active" 
                    offset={-100} 
                    smooth={true} 
                    spy={true} 
                    duration={500}>
                    <BiUser className="text-xl md:text-2xl cursor-pointer hover:text-primary transition" />
                </Link>
                
                <Link 
                    className="flex w-[50px] h-[50px] md:w-[60px] md:h-[60px] justify-center items-center cursor-pointer rounded-full" 
                    to="portfolio" 
                    activeClass="active" 
                    offset={-100} 
                    smooth={true} 
                    spy={true} 
                    duration={500}>
                    <BiCodeAlt className="text-xl md:text-2xl cursor-pointer hover:text-primary transition" />
                </Link>

            </div>
        </div>
    );
}
